import { colors } from "@mui/material";

const white = "#FFFFFF";
const black = "#000000";
const lightblack = "#1F2021";
const gray = "#515154";
const lightgray = "#F2F2F2";
const darkgray1 = "#666666";
const darkgray2 = "#333333";
const red = "#FF0000";
const green = "#00FF00";
const blue = "#0000FF";
//255,52,38
export default {
  black,
  white,
  lightblack: lightblack,
  gray1: darkgray1,
  gray2: darkgray2,
  lightgray: lightgray,
  blueAlert: "#E8F4FD",
  greenAlert: "#EDF7ED",
  orangeAlert: "#FFF4E5",
  redAlert: "#FDECEA",
  primary: {
    contrastText: white,
    dark: "#FF3426", //colors.deepPurple[900],
    main: "#FF3426", //color//.deepPurple[800],
    light: "#FF3426", //"#FF3426", //colors.deepPurple[100]
  },
  secondary: {
    contrastText: white,
    dark: "#000000", //colors.blue[900],
    main: "#000000", //colors.blue['A400'],
    light: "#000000", //colors.blue['A400'],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: black, //s"#FF3426",
    secondary: "#000000",
    gray: "#111111",
    link: colors.blue[600],
  },
  background: {
    default: "#F4F6F8",
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};
